/**
 * 基于localforage https://localforage.docschina.org/
 *
 */
/**新的缓存封装方法 */
import { singleRunPromise } from './adapter'
import md5 from 'crypto-js/md5'
import localforage from 'localforage'
import { parse } from 'qs'

/**记录上次回收缓存的时间 */
let oldTime = new Date().getTime()

/**缓存对象 */
class CacheObject {
  id
  timed
  type
  value

  get key() {
    return CacheObject.getKey(this.id, this.type)
  }

  constructor(obj) {
    this.id = obj.id
    this.type = obj.type
    this.value = obj.value
    this.timed = obj.timed
  }

  /**
   * create CacheObject by cache value of string type
   * @param {string} valueStr
   * @returns
   */
  static createByStr(valueStr) {
    if (!valueStr) return
    try {
      const obj = parse(valueStr)
      const cache = new CacheObject()
      cache.id = obj.id
      cache.timed = obj.timed
      cache.type = obj.type
      cache.value = obj.value
      return cache
    } catch (error) {
      console.error('createByStr,创建CacheObject异常', error)
    }
  }

  /**
   * get cache key by id and type
   * @param {string} id
   * @param {CacheType} type
   * @returns cache key
   */
  static getKey(id, type) {
    //强制md5
    return '_' + type + '_' + md5(id)
  }

  /**
   * get cache type by cache key
   * @param {string} key
   * @returns {int} 缓存类型
   */
  static getType(key) {
    if (key.indexOf('_') !== 0) {
      return CacheType.none
    } else {
      let type = key.split('_')[1]
      type = Number.parseInt(type)
      if (isNaN(type)) {
        return CacheType.none
      } else {
        return type
      }
    }
  }
}

/**数据缓存等级
 * GC只处理过期缓存
 */
export const CacheType = {
  /**其它不重要的数据 */
  other: 0,
  /**系统重要数据 token等*/
  system: 1,
  /**埋点数据 */
  point: 2,
  /**http请求缓存 */
  http: 3,
  /**页面数据缓存*/
  pageData: 4,
  /**登录级数据 登录状态数据*/
  login: 5,

  /**未归类 */
  none: NaN
}

/**
 * sync set cache
 * @param {{id, value, type, timed}} obj   timed:时间戳(只精确到秒)
 */
export async function setCache(obj) {
  let { id, value, type, timed } = obj
  //默认最低级
  if (!type) {
    type = CacheType.other
  }

  //过期时间
  if (!timed) {
    if (type == CacheType.login || type == CacheType.system) {
      timed = Date.parse(new Date()) + 2592000000 //30天
    } else {
      timed = Date.parse(new Date()) + 1800000 //3分钟
    }
  }

  const key = CacheObject.getKey(id, type)
  const values = {
    id,
    type,
    value,
    timed
  }

  /** set cache */
  //let err = false
  try {
    await localforage.setItem(key, values)
  } catch (error) {
    console.error('setCache', error)

    /**异步清除部分缓存 */
    singleRunPromise(
      'StorageGC',
      async () => {
        //要删除的类型
        const dels = [CacheType.other, CacheType.http, CacheType.point]
        await removeCacheByType(dels)
      },
      false
    )

    //err = true//不再做过期回收
  }

  /**自动回收过期缓存 */
  // if (!err) {
  //   cacheGC()
  // }
}

/**
 * 获取缓存  by id and type
 * @param {string} id
 * @param {CacheType} type
 * @param {timestamp} now
 * @returns
 */
export async function getCache(id, type, now) {
  const key = CacheObject.getKey(id, type)
  return await getCacheByKey(key, now)
}

/**
 * 根据缓存key获取缓存
 * @param {string} key
 * @returns
 */
export async function getCacheByKey(key, now) {
  let cache = await localforage.getItem(key)
  if (cache) {
    cache = new CacheObject(cache)
    timedGC(cache, now)
    return cache.value
  }
}

/**删除缓存 */
export async function removeCache(id, type) {
  const key = CacheObject.getKey(id, type)
  await localforage.removeItem(key)
}

/**删除缓存 注意key是MD5字符串*/
export async function removeCacheByKey(key) {
  await localforage.removeItem(key)
}

//#region 回收过期缓存
/** 回收过期缓存 异步*/
export async function cacheGC() {
  try {
    //100秒防抖
    if (new Date().getTime() - oldTime > 100000) {
      await singleRunPromise(
        'StorageGC',
        async () => {
          //异步去删除过期缓存
          const now = Date.parse(new Date())

          await localforage.iterate(function (value, key, iterationNumber) {
            // 此回调函数将对所有 key/value 键值对运行
            console.log("iterationNumber",iterationNumber)

            console.log([key, value])
            const cache = new CacheObject(value); // Store the CacheObject instance
            if (checkTimed(cache, now)) {
              localforage.removeItem(cache.key); // Use the cache variable
            }
          })
        },
        false
      )
      oldTime = new Date().getTime()
    }
  } catch (error) {
    console.error('gc,回收过期缓存', error)
  }
}
//#endregion

//#region 缓存过期回收
/**
 * 缓存过期回收
 * @param {CacheObject} cache
 * @param {timestamp} now 默认当前时间，循环调用时需要从外部传入
 */
async function timedGC(cache, now) {
  if (checkTimed(cache, now)) {
    localforage.removeItem(cache.key)
    cache.value = undefined
  }
}

/**
 * 检查缓存是否过期
 * @param {CacheObject} cache
 * @param {timestamp} now 默认当前时间，循环调用时需要从外部传入
 * @returns
 */
function checkTimed(cache, now) {
  if (!now) {
    now = Date.parse(new Date())
  }
  return cache.timed && cache.timed < now
}
//#endregion

//#region 根据类型回收缓存
/**
 * 根据类型回收缓存
 * @param {Array[CacheType]} types
 */
export async function removeCacheByType(types) {
  const keys = await localforage.keys()
  for (const e of keys) {
    if (types.includes(CacheObject.getType(e))) {
      await localforage.removeItem(e)
    }
  }
}
//#endregion

/**
 * 根据缓存类型获取缓存keys
 * @param {Array[CacheType]} types
 * @returns
 */
export async function getCacheKeysByTypes(types) {
  let keys = await localforage.keys()
  keys = keys.filter((key) => {
    return types.includes(CacheObject.getType(key))
  })
  return keys
}
